module.exports = __webpack_public_path__ + "static/quotes-truck-953a1e0e7e4e6a171e92a32d02bbbfef.png";